import { Component, Input } from '@angular/core';
import {
  WidgetDpiaV0GravityValueSelectorComponent
} from '../widgets/widget-dpia/v0/widget-dpia-v0-gravity-value-selector.component';
import { IoniconsFilled } from '@pt/pt-models';
import { DpiaEvalRow } from 'it/primatoo/openapi/api/org/schemas/dpia/dpiaevaluation/DpiaEvalRow';
import { DpiaColumn } from 'it/primatoo/openapi/api/org/schemas/dpia/dpiaevaluation/DpiaColumn';

/**
 * ATTENZIONE: questo componente è usato anche all'interno dell'editor della DPIA,
 * Li il suo funzionamento è corretto, se utilizzato altrove o clonarlo o evitare di modificare il comportamento nell'editor
 * nota di @giovanni
 */
@Component({
  selector: 'pt-dpia-stats-table',
  template: `
    <table class='table table-striped' *ngIf='columns || rows'>
      <thead>
      <tr>
        <th scope='col' class='upperLeftCorner' ></th>
        <th scope='col' class='upperLeftCorner'></th>
        <th scope='col' class='bg-threat text-center' [colSpan]='columns?.length'>
          {{threatLabel}}
        </th>
      </tr>
      <tr>
        <th scope='col' class='bg-demage' style="min-width: 100px">{{demageLabel}}</th>
        <th scope='col' class='bg-demage' style="min-width: 60px">{{typeLabel}}</th>
        <th scope='col' [ngClass]='{"w-col-fix": fixColWidth}' class='row-threat' *ngFor='let col of columns'>
          <div>{{col?.threatLabel}}</div>
        </th>
      </tr>
      </thead>

      <tbody>
      <tr *ngFor='let row of rows; index as i'>
        <td scope='row' class="padding-5">
          <div class='primary-label vertical-align-middle'>{{row.damageLabel}}</div>
        </td>
        <td class="padding-5">
          <div class='primary-label vertical-align-middle'>{{row.damageCategory}}</div>
        </td>
        <td *ngFor='let col of row.data' class='vertical-align-middle padding-5' [ngClass]='{"w-col-fix": fixColWidth}'>
          <ng-container *ngIf='col.riskValue >= 0'>
            <div *ngIf='col.riskLabel'
                 [ngClass]='getCssClass(col.riskValue)'
                 class='primary-label cell vertical-align-middle'>
              {{col.riskLabel}}
            </div>
          </ng-container>

          <ng-container *ngIf='col.riskValue < 0'>
            <div class='primary-label cell-error vertical-align-middle'
                 [style.color]='DPIA_ERROR'>
              <pt-icon [key]="IconInfo"
                       ngbTooltip='{{col.riskLabel}}'
                       class='widget-info-icon-color'></pt-icon>
            </div>
          </ng-container>

        </td>
      </tr>
      </tbody>
    </table>
  `,
  styles: [`
    .padding-5 {
      padding: 5px;
    }
    .upperLeftCorner {
      border: none;
      border-bottom: 2px solid #dee2e6;
    }

    .bg-threat {
      background: #ce1115;
      color: white;
      font-weight: bold;
    }

    .bg-demage {
      background: #E04500;
      color: white;
      font-weight: bold;
    }

    .row-threat {
      vertical-align: middle;
      text-align: center;
      font-weight: bold;
      font-size: 10px;
    }

    .primary-label {
      color: var(--bs-dark);
      font-size: 12px;
    }

    .secondary-label {
      font-size: 10px;
      color: var(--bs-gray);
    }

    .vertical-align-middle {
      vertical-align: middle;
    }

    .w-col-fix {
      max-width: 130px;
      width: 130px;
      min-width: 130px;
      padding: 0 2px;
    }

    .cell {
      display: block;
      text-align: center;
      font-size: 11px;
      padding: 5px;
      /*font-weight: bold;*/
    }

    .cell-error {
      text-align: center;
      font-size: 10px;
      padding: 0 5px;
      /*font-weight: bold;*/
      /*max-width: 84px;*/
    }

    .col {
      text-align: center;
      /*min-width: 100px;*/
    }

    .col .primary-label {
      text-align: center;
      height: 76px;
      display: flex;
      align-items: center;
      justify-content: center;
    }


    .very-high {
      border: solid 2px var(--ptHigh);
      border-radius: 6px;
    }

    .high {
      border: solid 2px var(--ptHigh);
      border-radius: 6px;
    }

    .medium-high {
      border: solid 2px var(--ptMediumHigh);
      border-radius: 6px;
    }

    .medium {
      border: solid 2px var(--ptMedium);
      border-radius: 6px;
    }

    .medium-low {
      border: solid 2px var(--ptMediumLow);
      border-radius: 6px;
    }

    .low {
      border: solid 2px var(--ptLow);
      border-radius: 6px;
    }
  `]
})
export class DpiaStatsTableComponent {
  @Input() threatLabel: string;
  @Input() demageLabel: string;
  @Input() typeLabel: string;

  @Input() columns: DpiaColumn[];
  @Input() rows: DpiaEvalRow[];
  @Input() fixColWidth = true;

  IconInfo = IoniconsFilled.infoCircle;

  DPIA_ERROR = '#DA0000';

  getCssClass(value: number): string {
    return WidgetDpiaV0GravityValueSelectorComponent.cssValutationResponse(value);
  }
}
